import React from "react";
import kpitLogo from "./../images/kpit_logo_new.png";
import CardBox from "./componentsEnhanced/CardBox";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";

const Navigator = () => (
    <div>
        <div>
            <Breadcrumb>
                <Breadcrumb.Item href="">
                    <Link to="">Home</Link>
                </Breadcrumb.Item>
            </Breadcrumb>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "25px",
                    gap: "100px",
                }}
            >
                <img src={kpitLogo} alt="" />
                <div id="displayBox">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "50px",
                        }}
                    >
                        <CardBox
                            path={"/welcome_automate_kpi"}
                            title={"AutomateKPI.AD"}
                            info={""}
                        />
                        <CardBox
                            path={"/welcome_scenario_catalogue"}
                            title={"Simulib.AD"}
                            info={""}
                        />
                        <CardBox
                            path={"/scenario_editor"}
                            title={" ScenGen.AD"}
                            info={"Description of ScenGen.AD"}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "50px",
                        }}
                    >
                        <CardBox
                            path={"/event_analyzer_filtering"}
                            title={" SceneExtract.AD"}
                            info={"Description of SceneExtract.AD"}
                        />
                        <CardBox
                            path={"/welcome"}
                            title={"TestManagementSuite.AD"}
                            info={"Description of TestManagementSuite.AD"}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Navigator;
